import { useContext, useEffect, useState, useMemo } from "react";
import LazyBlur from "./LazyBlur";
import { DataContext } from "~/contexts/Data";

const HeaderBg = ({ src, headerHeight, title }) => {
  const { screenWidth } = useContext(DataContext);
  const [width, setWidth] = useState(1920); // default safe fallback

  useEffect(() => {
    if (screenWidth >= 1920) setWidth(1920);
    if (screenWidth >= 1800) setWidth(1800);
    else if (screenWidth >= 1440) setWidth(1440);
    else if (screenWidth >= 1024) setWidth(1024);
    else if (screenWidth >= 768) setWidth(768);
    else if (screenWidth >= 480) setWidth(480);
    else setWidth(360);
  }, [screenWidth]);

  const transformedSrc = useMemo(() => {
    if (!src) return null;
    return `${src}?width=${width}&height=${headerHeight}&quality=80&format=webp&mode=crop&upscale=true`;
  }, [src, width]);

  if (!src) return null;

  return (
    <>
      {src && screenWidth > 1700 && (
        <LazyBlur
          alt="header blurred"
          style={{ height: headerHeight + "px" }}
          src={
            src +
            `?height=${
              headerHeight / 10
            }&blur=15&format=webp&mode=crop&upscale=true`
          }
          key={src + "blurred"}
          className="header-bg--blurred"
        />
      )}
      <LazyBlur
        alt={title}
        style={{ height: `${headerHeight}px` }}
        src={transformedSrc}
        key={src}
        className="header-bg"
      />
    </>
  );
};

export default HeaderBg;
